var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-photo"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead}}),_c('p',[_vm._v("相册")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }